// deps
import styled from "styled-components";

// internal-deps
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { IColors } from "@swiggy-private/dls-web-common/dist/components/types.internal";

const HIGHLIGHT_BULLET_POINT_SHINE_COLOR = "rgba(239, 211, 110, 0.8)";

export const DeliverySpeedPointTooltipTitle = styled(Text)`
    margin-bottom: 8px;
`;

export const Wrapper = styled.div`
    position: relative;
    z-index: 2;
`;

export const DeliverySpeedPoint = styled(Text)<{
    shimmer?: boolean;
    showTooltipBorder?: boolean;
    highlightColor?: keyof IColors;
}>`
    color: ${({ theme, highlightColor }) => {
        return highlightColor ? theme.colors[theme.colorMode]?.[highlightColor] : "transparent";
    }};
    background-color: ${({ theme }) => {
        return theme.colors[theme.colorMode].text_High_Emphasis;
    }};
    background-clip: text;
    -webkit-background-clip: text;
    background-size: 100%;
    background-position: -120px;
    background-repeat: no-repeat;
    z-index: 1;
    background-image: linear-gradient(
        40deg,
        transparent 0%,
        transparent 40%,
        ${HIGHLIGHT_BULLET_POINT_SHINE_COLOR} 50%,
        transparent 60%,
        transparent 100%
    );
    animation: ${(props) => (props.shimmer ? "text-shine 4s linear 5" : "none")};
    position: relative;

    /* because strikethrough doesn't appear with color: transparent, */
    /* and below styles are consistent with design, as well */
    & span[style="text-decoration: line-through;"] {
        position: relative;
        color: ${({ theme }) => {
            return theme.colors[theme.colorMode].text_Low_Emphasis;
        }};
        margin-right: ${({ theme }) => theme.spacing.xxxSmall};

        &::after {
            content: "";
            border-bottom: 1px solid ${({ theme }) => theme.colors[theme.colorMode].text_Low_Emphasis};
            width: 100%;
            position: absolute;
            right: 0;
            left: 1px;
            top: 45%;
            box-shadow: 0px 1px 0px 0px white;
        }
    }

    @keyframes text-shine {
        0% {
            background-position: -120px;
        }

        50%,
        100% {
            background-position: 210px;
        }
    }

    &:before {
        content: "";
        position: absolute;
        bottom: ${({ theme }) => theme.spacing.xxxSmall};
        left: 0;
        right: 0;
        border-top: ${({ theme, showTooltipBorder, highlightColor }) =>
            showTooltipBorder
                ? `1px dashed ${
                      theme.colors[theme.colorMode]?.[(highlightColor || "text_High_Emphasis") as keyof IColors]
                  }`
                : "none"};
    }
`;
